import React, {useContext} from "react";
import Grid from '@material-ui/core/Grid';
import LangSwitch from 'components/LangSwitch';
import Hidden from '@material-ui/core/Hidden';
import Rechercher from 'components/Rechercher';
import MenuMobile from 'components/MenuMobile';
import './TopBar.scss';
import {
  Link
} from "react-router-dom";
import { SettingsContext } from 'Providers/SettingsProvider';
function TopBar() {
    const { settings, removeScrollY } = useContext(SettingsContext);
    let classes='topbar';
    return <div className={classes}>
          <div className="topbar-inner">
            <div className="topbar-border">
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <div/>
                </Grid>
                <Hidden smDown>
                  <Grid item xs={12} md={9}>
                    <div/>
                  </Grid>
                </Hidden>
              </Grid>
            </div>
            <Hidden smDown>
            <Grid container alignContent="flex-end">
                <Grid item md={3}>
                    <Link onClick={()=>removeScrollY("/")} to="/" className="topbar-mainlink playlist-link">{settings.websitename}</Link>
                </Grid>
                <Grid item md={9}>
                    <Grid container alignContent="flex-end" spacing={2}>
                        <Grid item xs={8}>
                            <Rechercher/>
                        </Grid>
                        <Grid item xs={4}>
                            <LangSwitch/>
                            <a href="https://playlist.centredartlelait.com" className="topbar-mainlink front-link">{settings.sitename}</a>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            </Hidden>
            <Hidden mdUp>
            <Grid container alignContent="flex-end" className="xs">
                <Grid item xs={12} className="xs-title">
                    <Hidden mdUp>
                      <MenuMobile/>
                    </Hidden>
                    <Link onClick={()=>removeScrollY("/")} to="/" className="topbar-mainlink playlist-link">{settings.websitename}</Link>
                </Grid>
                <Grid container alignContent="flex-end" spacing={2} className="xs-utils">
                    <Grid item xs={8}>
                        <Rechercher/>
                    </Grid>
                    <Grid item xs={4}>
                        <LangSwitch align='right'/>
                    </Grid>
                </Grid>
            </Grid>
            </Hidden>
        </div>
    </div>;
}

export default TopBar;
